module.exports = __webpack_public_path__ + "static/media/process_5.4d57c0e8.png";